import PropTypes from "prop-types";
import "./SubHeader.scss";
import BackArrowIcon from "../../assets/icons/pageIcons/BackArrowIcon";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import { EditOutlined } from "@ant-design/icons";

const SubHeader = ({
  title,
  showBack = true,
  onBack,
  showRight = false,
  onRightClick,
  rightActionLabel = "Action",
  rightActionIcon,
  rightExtra,
  divider = true,
  compact = false,
  subTitle = ""
}) => {
  const rootClasses = [
    "subheader",
    divider ? "subheader--divider" : "",
    compact ? "subheader--compact" : "",
  ]
    .join(" ")
    .trim();

  return (
    <div className={rootClasses}>
      {/* LEFT: Back + Title + SubTitle */}
      <div className="subheader__left">
        <div className="subheader__titleRow">
          {showBack && (
            <button
              type="button"
              className="subheader__back"
              aria-label="Go back"
              onClick={onBack}
            >
              <BackArrowIcon />
            </button>
          )}
          <div>
            <h2>{title}</h2>
            {/* NEW: SubTitle for breadcrumbs/context */}
            {subTitle && <div className="subheader__subtitle">{subTitle}</div>}
          </div>
        </div>
      </div>

      {/* RIGHT: Extra content + Action Button */}
      {(rightExtra || (showRight && onRightClick)) && (
        <div className="subheader__right">
          {rightExtra && (
            <div className="subheader__right-extra">{rightExtra}</div>
          )}
          {showRight && onRightClick && (
            <ButtonComponent variant="primary" onClick={onRightClick}>
              {rightActionIcon || <EditOutlined />}
              {rightActionLabel}
            </ButtonComponent>
          )}
        </div>
      )}
    </div>
  );
};

SubHeader.propTypes = {
  title: PropTypes.string.isRequired,
  showBack: PropTypes.bool,
  onBack: PropTypes.func,
  showRight: PropTypes.bool,
  onRightClick: PropTypes.func,
  rightActionLabel: PropTypes.string,
  rightActionIcon: PropTypes.node,
  rightExtra: PropTypes.node,
  divider: PropTypes.bool,
  compact: PropTypes.bool,
  subTitle: PropTypes.node,
};

export default SubHeader;
